import content from './contentClient';
import dataSchemas from './dataSchemasClient';
import directData from './directDataClient';
import files from './filesClient';
import jobs from './jobsClient';
import lists from './listsClient';
import projects from './projectsClient';
import searchFiles from './searchFilesClient';
import tags from './tagsClient';
import tickets from './ticketsClient';
import journeys from './journeysClient';
import forms from './formsClient';
export default {
  content: content,
  dataSchemas: dataSchemas,
  directData: directData,
  files: files,
  jobs: jobs,
  lists: lists,
  projects: projects,
  searchFiles: searchFiles,
  tags: tags,
  tickets: tickets,
  journeys: journeys,
  forms: forms
};